import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class NativeCarousel270x70 extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    const bannerDetail = pagedetails.bannerImageDetails;
    if (bannerDetail === undefined) {
      return null;
    }
    var slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: false,
      slidesToShow: 2,
      slidesToScroll: 1
    };

    var arr = [];

    {
      bannerDetail
        ? bannerDetail.map((bannerimagedetails, j) => {
            arr.push({
              id: j,
              uId: bannerimagedetails.uId,
              imageUrl: bannerimagedetails.imageUrl,
              urlLink: bannerimagedetails.bannerUrlLink,
              bannerPos: bannerimagedetails.bannerPosition,
              componentPos: bannerimagedetails.componentPosition
            });
          })
        : '';
    }

    let imageGallery = arr.map((data, i) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        data.imageUrl.indexOf('?') == -1
          ? data.imageUrl
          : data.imageUrl.substr(0, data.imageUrl.indexOf('?'));
      return (
        <Col xs={6} key={i} className="gallery-section">
          <a
            href={data.urlLink}
            className="img-animate"
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${data.omponentPos}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${data.bannerPos}`}
            data-gtm-bnr-position={`${data.componentPos}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(data.imageUrl) || ''}`}
            data-gtm-bnr-id={`${data.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(data.imageUrl)}`} />
          </a>
        </Col>
      );
    });

    let imageList;

    if (arr.length > 2) {
      imageList = (
        <Slider {...slickSettings} ref="slick">
          {imageGallery}
        </Slider>
      );
    } else {
      imageList = imageGallery;
    }
    const classNames = `gallery-com${arr.length <= 2 ? ' row' : ''}`;

    return <div className={classNames}>{imageList}</div>;
  }
}

export default BannerWrapper(NativeCarousel270x70);
